import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { Login } from '../models/login';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginRepository {
  constructor(private http: HttpClient) {}

  /**
   * Generic HTTP POST wrapper to avoid duplicate code
   */
  private postRequest<T>(url: string, body: unknown, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    return this.http
      .post<T>(url, body, {
        headers,
        observe: 'response',
        withCredentials: true,
      })
      .pipe(
        map((res) => res),
        catchError(this.handleError),
      );
  }

  /**
   * Logs a user into SCS
   */
  login(username: string, password: string): Observable<HttpResponse<Login>> {
    return this.postRequest<Login>(environment.login.apiEndpoint, {
      username,
      password,
    });
  }

  /**
   * Logs out a user
   */
  logout(token: string): Observable<HttpResponse<void>> {
    const headers = new HttpHeaders().set('x-auth-token', token);
    return this.postRequest<void>(environment.login.logout, null, headers);
  }

  /**
   * Handles HTTP errors
   */
  private handleError(error: unknown): Observable<never> {
    console.error('LoginRepository Error:', error);
    return throwError(() => error);
  }
}
